export default __webpack_public_path__ + "static/media/1829.e0744bff.png";